/**
 * Track domain — the fundamental library entity.
 *
 * V6 model keeps the numeric `id` contract with the client (upload UI assigns)
 * but owner is now free-form (was a union in V5). `name` is the original
 * filename the user uploaded; `filename` is the server-side safe name.
 */
import { z } from "zod";
export const TrackSchema = z.object({
    id: z.number().int().nonnegative(),
    name: z.string().min(1),
    filename: z.string().min(1),
    owner: z.string().min(1),
    type: z.string().min(1),
    addedAt: z.number().int().nonnegative(),
    durationSec: z.number().positive().optional().nullable(),
    metadataTitle: z.string().optional().nullable(),
    metadataArtist: z.string().optional().nullable(),
    /** Unix seconds (not ms). null = never played. */
    lastPlayed: z.number().int().nullable().optional(),
    /** dB offset toward target LUFS when normalization is enabled. null = not scanned. */
    loudnessGainDb: z.number().nullable().optional(),
    /** Legacy Spotify track ID (read-only; no longer used for import). */
    spotifyTrackId: z.string().optional().nullable(),
    /** Exact YouTube Music / YouTube video ID (11 chars) used as durable import key. */
    youtubeMusicVideoId: z.string().optional().nullable(),
});
export const UploadTrackBodySchema = z.object({
    owner: z.string().min(1),
});
export const PatchPlayedBodySchema = z.object({
    /** Unix seconds. Defaults to now if omitted. */
    ts: z.number().int().optional(),
});
//# sourceMappingURL=tracks.js.map